import { SET_EVENTS_COLLECTIONS, SET_COLLETION_SCHEMA_LOADING, FETCH_COLLECTION_SCHEMA, FETCH_COLLECTION_SCHEMA_ERROR, FETCH_COLLECTION_SCHEMA_SUCCESS, SCHEMA_COMPUTED } from './constants';
export var setEventsCollections = function setEventsCollections(collections) {
  return {
    type: SET_EVENTS_COLLECTIONS,
    payload: {
      collections: collections
    }
  };
};
export var computeSchemaSuccess = function computeSchemaSuccess(collection, schema) {
  return {
    type: SCHEMA_COMPUTED,
    payload: {
      collection: collection,
      schema: schema
    }
  };
};
export var setCollectionSchemaLoading = function setCollectionSchemaLoading(colletion, isLoading) {
  return {
    type: SET_COLLETION_SCHEMA_LOADING,
    payload: {
      colletion: colletion,
      isLoading: isLoading
    }
  };
};
export var fetchCollectionSchema = function fetchCollectionSchema(collection) {
  return {
    type: FETCH_COLLECTION_SCHEMA,
    payload: {
      collection: collection
    }
  };
};
export var fetchCollectionSchemaSuccess = function fetchCollectionSchemaSuccess(collection, schema) {
  return {
    type: FETCH_COLLECTION_SCHEMA_SUCCESS,
    payload: {
      collection: collection,
      schema: schema
    }
  };
};
export var fetchCollectionSchemaError = function fetchCollectionSchemaError(error) {
  return {
    type: FETCH_COLLECTION_SCHEMA_ERROR,
    payload: {
      error: error
    }
  };
};